import { Text } from "tamagui";
import { jsx } from "react/jsx-runtime";
const SimpleText = ({
  children,
  ...rest
}) => {
  return /* @__PURE__ */jsx(Text, {
    ...rest,
    children
  });
};
export { SimpleText };
//# sourceMappingURL=SimpleText.mjs.map
